
import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function NewsletterSignup() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;

    setIsSubmitting(true);
    
    const formData = new URLSearchParams();
    formData.append('email', email);

    try {
      const response = await fetch('https://readdy.ai/api/form/d3naqu768806cmb3nahg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData,
      });

      if (response.ok) {
        setIsSubmitted(true);
        setEmail('');
      }
    } catch (error) {
      console.error('Newsletter signup failed:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-16 px-6 lg:px-8 bg-red-600">
      <div className="max-w-4xl mx-auto text-center">
        <div className="mb-8">
          <h2 className="text-4xl font-bold text-white mb-4" style={{ fontFamily: '"Libre Baskerville", serif' }}>
            Stay Connected with Canadian Literature
          </h2>
          <p className="text-xl text-red-100 max-w-2xl mx-auto">
            Get our weekly newsletter featuring the latest reviews, author interviews, and literary events from coast to coast to coast.
          </p>
        </div>

        {isSubmitted ? (
          <div className="bg-white/10 rounded-lg p-8 max-w-lg mx-auto">
            <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-4">
              <i className="ri-check-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-semibold text-white mb-2">Thank You!</h3>
            <p className="text-red-100">
              You've successfully subscribed to The Maple Leaf Review newsletter. 
              Welcome to our literary community!
            </p>
          </div>
        ) : (
          <form 
            id="newsletter-signup"
            data-readdy-form
            onSubmit={handleSubmit} 
            className="max-w-lg mx-auto"
          >
            <div className="flex flex-col sm:flex-row gap-4">
              <div className="flex-1">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email address"
                  required
                  className="w-full px-4 py-3 rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-white"
                />
              </div>
              <Button 
                type="submit" 
                disabled={isSubmitting}
                variant="secondary"
                size="lg"
                className="whitespace-nowrap"
              >
                {isSubmitting ? (
                  <>
                    <i className="ri-loader-4-line animate-spin mr-2"></i>
                    Subscribing...
                  </>
                ) : (
                  <>
                    <i className="ri-mail-line mr-2"></i>
                    Subscribe
                  </>
                )}
              </Button>
            </div>
            <p className="text-red-100 text-sm mt-4">
              Join over 15,000 readers who trust us to curate the best of Canadian literature. 
              Unsubscribe anytime.
            </p>
          </form>
        )}
      </div>
    </section>
  );
}
